<template>
	<div v-if="enabled" class="image-magnifier">
		<div
			@mouseenter="onMouseEnter"
			@mousemove="onMouseMove"
			@mouseleave="onMouseLeave"
			@mouseover="onMouseOver"
			@wheel="onWheel"
			ref="image-wrapper"
		>
			<slot></slot>
		</div>
		<div class="image-magnifier__mask" :style="maskStyle" ref="mask">
			<!-- 		<div v-if="debug" class="debug">
				Mask width: {{ Number(maskWidth).toFixed(2) }}<br />
				Mask height: {{ Number(maskHeight).toFixed(2) }}<br />
				Mask X: {{ Number(maskX).toFixed(2) }}<br />
				Mask Y: {{ Number(maskY).toFixed(2) }}<br />
			</div> -->
		</div>
	</div>
	<div v-else>
		<slot></slot>
	</div>
</template>

<script>
import productSheetDesignMixin from '../mixins/productSheetDesignMixin'

export default {
	mixins: [productSheetDesignMixin],
	props: {
		product: Object,
		img: {
			type: Object,
		},
	},
	data() {
		return {
			zoomShow: false,
			imgRect: '',
			maskRect: '',
			maskX: 0,
			maskY: 0,
			maskWidth: 200,
			maskHeight: 200,
			zoomWindowYPos: null,
		}
	},
	computed: {
		/* 	debug() {
			return false
		}, */
		enabled() {
			return this.$b.d && this.psdEnableDesktopZoom && this.img?.type == 'image'
		},
		maskStyle() {
			return {
				width: `${this.maskWidth}px`,
				height: `${this.maskHeight}px`,
				transform: `translate(${this.maskX}px, ${this.maskY}px)`,
				visibility: this.zoomShow ? 'visible' : 'hidden',
			}
		},
	},
	methods: {
		onMouseEnter(e) {
			// calcular las dimensiones visibles del panel derecho y ajustar las dimensiones de la mascara
			const zoomWindow = this.getZoomWindow()
			if (!zoomWindow) {
				return
			}
			const { width: zoomWindowWidth } = zoomWindow.getBoundingClientRect()
			this.maskWidth = zoomWindowWidth * 0.35

			const { width: zoomContainerWidth, height: zoomContainerHeight } = this.calcVisibleDimension(
				this.getZoomWindowContainer()
			)
			const ratio = zoomContainerWidth / zoomContainerHeight
			this.maskHeight = this.maskWidth / ratio

			this.zoomShow = true
		},
		onMouseMove(e) {
			this.imgRect = this.$refs['image-wrapper']?.getBoundingClientRect()
			this.maskRect = this.$refs.mask?.getBoundingClientRect()

			if (!this.imgRect || !this.maskRect) {
				return
			}

			this.maskX = this.outXCheck(e.clientX - this.imgRect.left)
			this.maskY = this.outYCheck(e.clientY - this.imgRect.top)

			const zoomImg = this.getZoomImage()
			if (!zoomImg) {
				return
			}

			// desplazar la imagen de zoom proporcionalmente al desplazamiento de
			// la mascara en la imagen original
			zoomImg.style.top = `${-this.maskY * 2.8}px`
			zoomImg.style.left = `${-this.maskX * 2.8}px`
		},
		onWheel() {
			this.zoomShow = false
			this.removeZoomWindow()
		},
		onMouseLeave() {
			/*
			const zoomWindow = this.getZoomWindow()
			if (zoomWindow) {
				zoomWindow.style.display = 'none'
			}
 			*/
			this.zoomShow = false
			this.removeZoomWindow()
		},
		outXCheck(x) {
			x = x - this.maskRect.width / 2
			if (x < 0) {
				return 0
			}
			if (x + this.maskRect.width > this.imgRect.width) {
				return this.imgRect.width - this.maskRect.width
			}
			return x
		},
		outYCheck(y) {
			y = y - this.maskRect.height / 2
			if (y < 0) {
				return 0
			}
			if (y + this.maskRect.height > this.imgRect.height) {
				return this.imgRect.height - this.maskRect.height
			}
			return y
		},
		calcVisibleDimension(element) {
			const rect = element?.getBoundingClientRect()

			if (!rect) {
				return { width: 0, height: 0 }
			}
			// Get window size
			const windowHeight = window.innerHeight || document.documentElement.clientHeight
			const windowWidth = window.innerWidth || document.documentElement.clientWidth

			// Calc visible borders
			const top = Math.max(rect.top, 0)
			const left = Math.max(rect.left, 0)
			const bottom = Math.min(rect.bottom, windowHeight)
			const right = Math.min(rect.right, windowWidth)

			// Calc visible dimensions
			const visibleWidth = right - left
			const visibleHeight = bottom - top

			return {
				width: Math.max(0, visibleWidth),
				height: Math.max(0, visibleHeight),
			}
		},
		createZoomWindow() {
			const zoomWindow = document.createElement('div')
			zoomWindow.id = 'zoom-window'
			zoomWindow.style.position = 'absolute'

			zoomWindow.style.left = '0px'

			const zoomWindowContainer = this.getZoomWindowContainer()

			/*
			const top = zoomWindowContainer.getBoundingClientRect().top
			if (top < 0) {
				zoomWindow.style.top = `${top * -1}px`
			} else {
				zoomWindow.style.top = '0px'
			}
			*/

			zoomWindow.style.top = '0px'

			zoomWindow.style.overflow = 'hidden'
			zoomWindow.style.border = '1px solid rgb(148, 148, 148)'
			zoomWindow.style.boxShadow = 'rgba(0, 0, 0, 0.25) 0px 6px 8px 2px'
			zoomWindow.style.background = 'white'

			const zoomImage = document.createElement('img')
			zoomImage.id = 'zoom-image'
			zoomImage.style.position = 'absolute'
			zoomImage.style.top = '0px'
			zoomImage.style.left = '0px'
			zoomImage.style['max-width'] = 'none'
			zoomImage.src = this.img.fullUrl

			zoomImage.style.width = '1500px'
			zoomImage.style.height = '1500px'

			const { width, height } = this.calcVisibleDimension(zoomWindowContainer)
			zoomWindow.style.width = `${width - 5}px`
			zoomWindow.style.height = `${height - 5}px`

			zoomWindow.appendChild(zoomImage)
			zoomWindowContainer.appendChild(zoomWindow)
		},
		onMouseOver() {
			const media = this.img
			if (media.type != 'image') return

			/* const zoomImage = this.getZoomImage()
			if (zoomImage) {
				const { width, height } = this.calcVisibleDimension(this.zoomWindowContainer())
				const zoomWindow = this.getZoomWindow()
				zoomWindow.style.width = `${width - 5}px`
				zoomWindow.style.height = `${height - 5}px`

				zoomWindow.style.display = 'block'
				zoomImage.src = media.fullUrl
			} else {
				this.createZoomWindow()
			} */
			this.createZoomWindow()
		},
		removeZoomWindow() {
			const zoomWindow = this.getZoomWindow()
			if (zoomWindow?.parentNode) {
				zoomWindow.parentNode.removeChild(zoomWindow)
			}
		},
		getZoomWindowContainer() {
			return document.getElementById('zoom-window-container')
		},
		getZoomWindow() {
			return document.getElementById('zoom-window') || {}
		},
		getZoomImage() {
			return document.getElementById('zoom-image')
		},
	},
}
</script>

<style lang="scss" scoped>
.image-magnifier {
	position: relative;
	cursor: move;

	&__mask {
		position: absolute;
		left: 0;
		top: 0;
		will-change: transform;
		pointer-events: none;
		z-index: 1000;
		background-color: #409eff;
		opacity: 0.5;

		.debug {
			color: red;
			font-size: 18px;
		}
	}
}
</style>

